const routes = /** @type {const} */ ({
  admin: {
    root: '/',
  },
})

export { routes }
